export default {
  namespaced: true,
  state: {
    loggedIn: false,
    extension: null,
    userId: '',
    userName: '',
    roles: '',
    accessToken: '',
    refreshToken: ''
  },
  mutations: {
    create (state, data) {
      state.userId = data.userId
      state.userName = data.userName
      state.roles = data.roles
      state.accessToken = data.accessToken
      state.refreshToken = data.refreshToken
      state.loggedIn = true
      state.extension = new Date()
    },
    rename (state, data) {
      state.userName = data.userName
      state.roles = data.roles
      state.extension = new Date()
    },
    update (state, data) {
      state.accessToken = data.newToken
    },
    extension (state, data) {
      state.extension = new Date()
    },
    destroy (state) {
      state.userId = ''
      state.userName = ''
      state.roles = ''
      state.token = ''
      state.loggedIn = false
      state.extension = null
    }
  },
  actions: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js